import store from '@/store';
import router from '@/router';
import {Browser} from '@capacitor/browser';
import Message from '@/lib/base/message';
import i18n from '@/i18n/index.js';
import openHomePage from '@/lib/base/openHomePage';
import {manifest} from '@/constant/env.js';

/**
 * 推波事件處理
 * @param {Object} info 點擊推波內容
 */
const clickNotificationHandler = async (info) => {
  if (info) {
    const {name, coursePlan} = info;
    let {url} = info;
    if (coursePlan) {
      const plans = store.getters['course/plans'];
      const currentPlan = store.getters['course/currentPlan'];
      const newPlan = plans.find((plan) => plan.id === coursePlan);

      if (newPlan && newPlan.id !== currentPlan?.id) {
        store.commit('course/setCurrentPlan', newPlan);
        Message.success(i18n.t('已幫您切換至{name}課程', {name: newPlan.name}));
      }
    }

    if (name === 'coupon') {
      url = manifest.homePageUrl + 'origin/#/userSpace?tab=COUPON'; // 特例：優惠券點擊後跳轉到官網的個人空間的優惠券頁面
    }

    if (url) {
      if (url.includes(manifest.homePageUrl)) {
        const path = url.replace(manifest.homePageUrl, '') || '/';
        store.commit('env/setIsLoading', true);
        const username = store.getters['user/userData']?.username;
        await openHomePage({path, isNoLogin: false, username});
        store.commit('env/setIsLoading', false);
      } else {
        Browser.open({
          url,
          presentationStyle: 'popover',
        });
      }
    }
    if (name) {
      let params;
      let query;
      if (info.params) {
        params =
          typeof info.params === 'string'
            ? JSON.parse(info.params)
            : info.params;
      }
      if (info.query) {
        query =
          typeof info.query === 'string' ? JSON.parse(info.query) : info.query;
      }
      router.push({name, params, query});
    }
  }
};
export default clickNotificationHandler;
